<template>
    <div class="profil-component">
        <v-container class="pa-1">
            <v-row dense>
                <v-col cols="12">
                    <v-card tile>
                        <v-card-title class="headline">
                            <div class="leftside">
                                <i class="mdi mdi-account-circle"></i> {{$t('messages.details.profil')}}
                                <span class="statut" :class="this.leadInfo.finalStatut">{{leadStatut}}</span>
                            </div>
                            <i class="mdi mdi-lead-pencil" @click="$router.push({ name: 'EditLead' , params: { code: code, id:lead.id, lead: lead } })"></i>
                        </v-card-title>
                        <v-card-text class="content">
                            <div class="lead-name"><b>{{lead.prenom}} {{lead.nom}}</b></div>
                            <div class="phone-info">
                                <p>{{$t('messages.details.mobile')}} : <span v-if="lead.telephone_mobile != ''">{{lead.telephone_mobile}}</span><span v-if="lead.telephone_mobile == ''">N/C</span></p>
                                <p>{{$t('messages.details.fixe')}} : <span v-if="lead.telephone_fixe != ''">{{lead.telephone_fixe}}</span><span v-if="lead.telephone_fixe == ''">N/C</span></p>
                                <p>{{$t('messages.leadform.email')}} : <span v-if="lead.email != ''">{{lead.email}}</span><span v-if="lead.email == ''">N/C</span></p>
                            </div>
                            <div class="adress-info">
                                <p>{{$t('messages.details.adresse')}} :</p>
                                <span v-if="!leadAdresse1 && !leadAdresse2 && leadVille == ''">N/C</span>
                                <p v-if="leadAdresse1">{{this.lead.adresse.rue1}}</p>
                                <p v-if="leadAdresse2">{{this.lead.adresse.rue2}}</p>
                                <p v-if="leadVille != ''">{{leadVille}}</p>
                            </div>
                            <div v-if="lead.source_inscription" class="inscription">Source d'inscription : <b>{{lead.source_inscription}}</b></div>
                            <div v-if="dateInscription !== false && dateInscription.length > 0">Date d'inscription : <b>{{dateInscription[0]}}</b></div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col>
                    <v-card tile>
                        <v-card-title class="headline">
                            <div class="leftside">
                                <i class="mdi mdi-calendar"></i> {{$t('messages.details.rdv')}} 
                               <span class="subStatus" v-if="subStatuts && subStatuts.length > 0">
                                    <span class="sub" v-for="substatut in subStatuts" :key="substatut" :class="substatut">
                                        {{$t('messages.statuts.'+substatut)}}
                                    </span>
                                </span>
                            </div>
                            <span>
                                <a v-if="this.lead.rendez_vous.length > 0 && leadInfo.rdv[0].est_physique === false" :href="visioLink"><i class="mdi mdi-video"></i></a>
                                <i v-if="this.lead.rendez_vous.length > 0" class="mdi mdi-lead-pencil" @click="$router.push({name: 'AddRdv', params: {code: code, idLead: lead.id, mode: 'edit'}})"></i>
                                <i v-if="this.lead.rendez_vous.length == 0" class="mdi mdi-plus-circle" @click="$router.push({name: 'AddRdv', params: {code: code, idLead: lead.id, mode: 'create'}})"></i>
                            </span>
                        </v-card-title>
                        <v-card-text class="content" v-if="this.lead.rendez_vous.length > 0">
                            <p v-if="this.lead.rendez_vous[0].jour">{{$t('messages.details.date')}} : {{this.lead.rendez_vous[0].jour}}</p>
                            <p v-if="this.lead.rendez_vous[0].libelle">{{$t('messages.details.heure')}} : {{this.lead.rendez_vous[0].libelle}}</p>
                            <p v-if="nb_personnes">{{nb_personnes}}</p>
                            <p v-if="this.lead.rendez_vous[0].commentaire != ''">{{ this.lead.rendez_vous[0].commentaire }}</p>
                            <v-row dense v-if="this.lead.rendez_vous[0].id">
                                <v-col cols="12" class="text-center">
                                    <v-btn-toggle    
                                    v-model="leadInfo.rdv[0].est_physique"                          
                                    tile
                                    color="primary"
                                    dense
                                    mandatory
                                    group
                                    @change="changeLead"
                                    >
                                        
                                        <v-btn :value="valueFalse">
                                            Rdv Visio
                                        </v-btn>
                                        <v-btn :value="valueTrue">
                                            Rdv Physique
                                        </v-btn>
                                        <v-btn :value="valueNull">
                                            N/C
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                                <v-col cols="6" class="text-left question">
                                {{$t('messages.todo.venu')}}
                                </v-col>
                                <v-col cols="6">
                                    <v-btn-toggle    
                                    v-model="leadInfo.rdv[0].venu"                          
                                    tile
                                    color="primary"
                                    dense
                                    mandatory
                                    group
                                    @change="changeLead"
                                    >
                                        <v-btn :value="valueNull">
                                            {{$t('messages.todo.nc')}}
                                        </v-btn>
                                        <v-btn :value="valueTrue">
                                            {{$t('messages.todo.oui')}}
                                        </v-btn>
                                        <v-btn :value="valueFalse">
                                            {{$t('messages.todo.non')}}
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                                <v-col v-show="leadInfo.rdv[0].venu === true" cols="6" class="text-left question">
                                {{$t('messages.todo.vendu')}}
                                </v-col>
                                <v-col v-show="leadInfo.rdv[0].venu === true" cols="6">
                                    <v-btn-toggle   
                                    v-model="leadInfo.rdv[0].vendu"                           
                                    tile
                                    color="primary"
                                    dense
                                    mandatory
                                    group
                                    @change="changeLead"
                                    >
                                        <v-btn :value="valueNull">
                                            {{$t('messages.todo.nc')}}
                                        </v-btn>
                                        <v-btn :value="valueTrue">
                                            {{$t('messages.todo.oui')}}
                                        </v-btn>
                                        <v-btn :value="valueFalse">
                                            {{$t('messages.todo.non')}}
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                                <v-col v-show="leadInfo.rdv[0].vendu === true" cols="5" class="text-left question">
                                    Type de vente
                                    </v-col>
                                    <v-col v-show="leadInfo.rdv[0].vendu === true" cols="7">
                                        <v-btn-toggle   
                                        v-model="leadInfo.rdv[0].type_vente"                           
                                        tile
                                        color="primary"
                                        dense
                                        mandatory
                                        group
                                        @change="changeLead"
                                        >
                                            <v-btn :value="valueNull">
                                                NC
                                            </v-btn>
                                            <v-btn value="VN">
                                                VN
                                            </v-btn>
                                            <v-btn value="VO">
                                                VO
                                            </v-btn>
                                            <v-btn value="VD">
                                                VD
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                    <v-col v-show="leadInfo.rdv[0].type_vente !== valueNull" cols="5" class="text-left question">
                                    Financement
                                    </v-col>
                                    <v-col v-show="leadInfo.rdv[0].type_vente !== valueNull" cols="7">
                                        <v-btn-toggle   
                                        v-model="leadInfo.rdv[0].financement"                           
                                        tile
                                        color="primary"
                                        dense
                                        mandatory
                                        group
                                        @change="changeLead"
                                        >
                                            <v-btn :value="valueNull">
                                                {{$t('messages.todo.nc')}}
                                            </v-btn>
                                            <v-btn :value="valueTrue">
                                                {{$t('messages.todo.oui')}}
                                            </v-btn>
                                            <v-btn :value="valueFalse">
                                                {{$t('messages.todo.non')}}
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    props: ['code', 'lead'],
    data() {
        return {
            test: true,
            valueNull : -1,
            valueTrue : true,
            valueFalse : false,
            leadInfo: {},
            updateThis:false,
        }
    },
    created() {
        if(Object.keys(this.$store.state.leads).length === 0){
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    this.$store.dispatch('setLoader', false)
                    const leads = this.$store.state.leads;
                    Object.assign(this.leadInfo, leads.find(e => e.code_lead == this.lead.code_lead))
                })
            })
        } else {
            const leads = this.$store.state.leads;
            Object.assign(this.leadInfo, leads.find(e => e.code_lead == this.lead.code_lead))
        }
        setTimeout((e) => {
            this.updateThis = true;
        }, 1000)
    },
    methods: {
        changeLead: function(){
            if(this.updateThis){
                let leadInfoUpdate = this.leadInfo;
                let leadUpdate = this.lead;
                this.$store.dispatch('changeLead', leadInfoUpdate).then((e) => {
                    let rdvPayload = {
                        id_rendez_vous: leadInfoUpdate.rdv[0].id,
                        id_utilisateur: leadInfoUpdate.id,
                        data: 
                            {
                                commentaire: leadInfoUpdate.rdv[0].commentaire,
                                est_venu: leadInfoUpdate.rdv[0].venu,
                                avec_vente: leadInfoUpdate.rdv[0].vendu,
                                VN_VO_VD: leadInfoUpdate.rdv[0].type_vente,
                                est_physique: leadInfoUpdate.rdv[0].est_physique,
                                financement: leadInfoUpdate.rdv[0].financement
                            }
                    }
                    this.$store.dispatch('updateRdv', rdvPayload).then((e) => {
                        this.$store.dispatch('setStatut', leadInfoUpdate).then((e) => {
                            const leadToSet = this.$store.state.leads.find(e => e.code_lead == this.lead.code_lead);
                            this.leadInfo = Object.assign({}, leadToSet)
                        })
                    })
                })
            }
        }
    },
    computed: {
        dateInscription: function() {
            const leadHistory = this.lead.historiques;
            
            if(leadHistory.length > 0){
                const test = [];
                leadHistory.forEach(element => {
                    if(element.action == "Inscription du lead"){
                        test.push(element.date_ajout)
                    }
                });
                return test
            } else {
                return false
            }
        },
        visioLink: function() {
            return "https://rdv-visio.fr/uys_"+this.lead.code_lead
        },
        subStatuts:function(){
            return this.leadInfo.finalSubStatut
        },
        nb_personnes: function() {
            if(this.lead.rendez_vous.length > 0 && this.lead.rendez_vous[0].pass){
                if(this.lead.rendez_vous[0].pass > 1){
                    return this.lead.rendez_vous[0].pass + " " + this.$t('messages.details.personnes')
                }
            } else {
                return this.$t('messages.details.one_personne')
            }
            return false
        },
        leadAdresse1: function() {
            if(this.lead.adresse && this.lead.adresse.rue1 && this.lead.adresse.rue1 !="") {
                return true
            }
            return false
        },
        leadAdresse2: function() {
            if(this.lead.adresse && this.lead.adresse.rue2){
                return true
            }
            return false
        },
        leadVille: function(){
            let ville = "";
            if(this.lead.adresse.code_postal && this.lead.adresse.code_postal != ""){
                ville += this.lead.adresse.code_postal;
            }
            if(this.lead.adresse.code_postal && this.lead.adresse.code_postal != "" && this.lead.adresse.ville && this.lead.adresse.ville != ""){
                ville +=  " - ";
            }
            if(this.lead.adresse.ville && this.lead.adresse.ville != ""){
                ville +=  this.lead.adresse.ville;
            }
            return ville
        },

        leadStatut: function(){
            switch (this.leadInfo.finalStatut) {
                case "echec":
                    return this.$t('messages.statuts.echec')
                break;
                case "passage":
                    return this.$t('messages.statuts.passage')
                break;
                case "rdvQualifier":
                    return this.$t('messages.statuts.rdvQualifier')
                break;
                case "rdvaQualifier":
                    return this.$t('messages.statuts.rdvaQualifier')
                break;
                case "nouveau":
                    return this.$t('messages.statuts.nouveau')
                break;
                case "rdvaConfirmer":
                    return this.$t('messages.statuts.rdvaConfirmer')
                break;
                case "ARLP":
                    return this.$t('messages.statuts.ARLP')
                break;
                case "ARRP":
                    return this.$t('messages.statuts.ARRP')
                break;
                case "wait":
                    return this.$t('messages.statuts.wait')
                case "black":
                    return this.$t('messages.statuts.black')
                break;
            }
        }
    },
    
}
</script>
<style lang="scss">
.profil-component {
    .headline {
        border-bottom:1px solid #CCC;
        color: #081525;
        display:flex;
        align-items: center;
        justify-content: space-between;
        .leftside {
            display:flex;
            align-items: center;
            justify-content: flex-start;
            i {
                margin-right:10px;
            }
        }
        
        .subStatus {
            display:flex;
            align-items: center;
            .sub {
                margin-left:10px;
                font-size:0.6em;
                padding: 3px 5px;
                line-height: 1.4em;
                background-color:#AAA;
                border-radius:5px;
                color:#FFF;
                &.venu, &.achat, &.achat_vo, &.achat_vn, &.achat_vd {
                    background-color: green;
                }
                &.novenu, &.noachat {
                    background-color: red;
                }
                &.venu, &.novenu {
                    margin-right:5px;
                }
            }
        }
        .statut {
            margin-left:10px;
            font-size:0.6em;
            padding: 3px 5px;
            line-height: 1.4em;
            background-color:#AAA;
            border-radius:5px;
            color:#FFF;
            &.ARLP, &.ARRP, &.rdvaConfirmer, &.rdvaQualifier {
                background-color: orange;
            }
            &.rdvQualifier {
                background-color: green;
            }
            &.echec {
                background-color: red;
            }
            &.black {
                background-color: #000;
            }
        }
    }
    i.mdi-video {
        margin-right:10px;
    }
    .content {
        padding-top:16px !important;
        color:rgba(0,0,0,1) !important;
        p {
            margin-bottom:0;
        }
        .lead-name{
            font-size: 1rem;
            margin-bottom:10px;
        }
        .phone-info {
            p {
                margin-bottom:0;
            }
        }
        .adress-info {
            margin-top:10px;
            p {
                margin-bottom:0;
            }
        }
        .question {
            display:flex;
            align-items:center;
        }
        .inscription {
            margin-top:10px;
        }
    }
}
    
</style>